// E-Mail-Vorlagen: die eine Quelle für alle Mails der Software (Prototyp Cockpit › E-Mail-Vorlagen). Reine Logik, von Server und Oberfläche genutzt.
// Der Katalog (vorlagen-katalog.ts) liefert die Erstfassungen, Leons Änderungen stehen in mail_vorlage; wirksam ist genau eine Fassung (wirksam()).

export type VlStatus = 'auto' | 'manuell' | 'aus' | 'anruf' | 'vorbelegt';
export type VlAbnahme = 'ok' | 'offen' | 'entwurf' | 'vorschlag' | 'fehlt' | 'geaendert';
export type VlFuss = 'bh' | 'kalt' | 'person' | 'team' | 'kal';
export interface VlText { betreff: string | null; text: string }
/** wann, wer, was */
export type VlVerlauf = [string, string, string];
export interface Vorlage {
  id: string; ber: string; gruppe?: string; leist?: string; name: string; wann: string; abs: string; fuss: VlFuss; ph?: string; pflicht?: string[];
  betreff?: string | null; text?: string;
  st: VlStatus; stOpt?: VlStatus[]; an?: string; betreffTxt?: string; var?: Record<string, { betreff: string; text: string }>; varA?: Record<string, { wann?: string; kenn?: string; anhang?: string }>;
  abn: VlAbnahme; abnTxt: string; aufgaben?: [string, string, string[]?][] | null; hinweis?: string; quelle: string; verlauf: VlVerlauf[]; kenn?: string; ref?: string; anhang?: string;
  kal?: boolean; art?: string; erin?: boolean; absage?: boolean; tage?: number; versuche?: number; ort?: string; bw?: Record<string, string>;
}
export interface VlAnlass { name: string; ber: string; kenn: string; wann: string; anhang: string }
export interface VorlagenKatalog {
  VL_BER: [string, string, string][]; VL_FUSS: Record<VlFuss, [string, string]>; VL_PH: Record<string, string[]>; VL_BW: Record<string, string>; VL_AN: Record<string, string>;
  VLA: Record<string, VlAnlass>; VL_AB: Record<VlAbnahme, [string, string]>; VL_ST: Record<VlStatus, [string, string]>; VL_ST_TXT: Record<string, string>; VL: Vorlage[];
}
/** Was Leon geändert hat (Zeile in mail_vorlage) */
export type VlAenderung = Partial<Pick<Vorlage, 'st' | 'tage' | 'versuche' | 'abn' | 'abnTxt' | 'betreff' | 'text' | 'var'>>;

/** Wirksame Fassung: Katalog, darüber Leons Änderungen; je Reiter einzeln */
export function wirksam(v: Vorlage, wert: VlAenderung = {}, verlauf: VlVerlauf[] = []): Vorlage {
  return { ...v, ...wert, ...(v.var ? { var: { ...v.var, ...wert.var } } : {}), verlauf: [...verlauf, ...v.verlauf] };
}
/** Text der Vorlage oder des Reiters */
export const vlSrc = (v: Vorlage, k?: string | null): VlText => v.var ? v.var[k ?? ''] ?? Object.values(v.var)[0] : { betreff: v.betreff ?? null, text: v.text ?? '' };
export const vlVk = (v: Vorlage, k?: string | null) => v.var ? (k && v.var[k] ? k : Object.keys(v.var)[0]) : null;

const PH = /\{([^{}\n]*)\}/g;
/** Prüfung beim Tippen und beim Speichern: unbekannte Platzhalter und offene Klammern sperren, fehlende Pflichtteile warnen nur */
export function vlCheck(v: Vorlage, PHL: Record<string, string[]>, betreff: string | null | undefined, text: string) {
  const s = (betreff || '') + '\n' + text, ph = PHL[v.ph ?? ''] ?? [], found = [...s.matchAll(PH)].map(m => m[1]);
  const unbekannt = [...new Set(found.filter(p => !ph.includes(p)))], fehlt = (v.pflicht ?? []).filter(p => !found.includes(p));
  const offen = (s.match(/\{/g) ?? []).length !== (s.match(/\}/g) ?? []).length;
  return { unbekannt, fehlt, offen, ok: !unbekannt.length && !offen };
}
export function vlWarnN(v: Vorlage, PHL: Record<string, string[]>): number {
  if (v.ref) return 0;
  const n = (v.var ? Object.values(v.var) : [vlSrc(v)]).reduce((a, x) => { const c = vlCheck(v, PHL, x.betreff, x.text); return a + c.unbekannt.length + c.fehlt.length + (c.offen ? 1 : 0); }, 0);
  return n + (v.abn === 'fehlt' ? 1 : 0);
}
/** Vorschau: bekannte Platzhalter füllen, unbekannte bleiben sichtbar stehen */
export const vlFill = (s: string, w: Record<string, string>) => s.replace(PH, (m, p: string) => p in w ? w[p] : m);
/** Versand: Text füllen; was keinen Wert hat, steht in fehlt (dann geht die Mail nicht raus) */
export function vlAusfuellen(t: VlText, w: Record<string, string | null | undefined>) {
  const fehlt = new Set<string>();
  const f = (s: string) => s.replace(PH, (_, p: string) => { const x = w[p]; if (!x) fehlt.add(p); return x ?? ''; }).replace(/\n{3,}/g, '\n\n');
  return { betreff: f(t.betreff ?? ''), text: f(t.text), fehlt: [...fehlt] };
}
/** Satz statt Zeile: die ganze Zeile mit dem Platzhalter wird ersetzt (Beratung ohne Buchungslink, Hinweis der Vorlage s2) */
export const zeileErsetzen = (text: string, ph: string, satz: string) => text.split('\n').map(z => z.includes(`{${ph}}`) ? satz : z).join('\n');
export const OHNE_BUCHUNGSLINK = 'Für den Termin der ersten Beratungsstunde meldet sich Ihr Berater in den nächsten Tagen bei Ihnen.';

/** Welche Vorlage für den Projektstart: Folgeleistung eine für alle, Einstiegsleistung je Leistung und Kundenportal */
export function startVorlage(leistung: string, portal: boolean, folge: boolean): string {
  if (folge) return 's6';
  if (/^Website/i.test(leistung)) return 's5';
  if (/^Konzept/i.test(leistung)) return portal ? 's3' : 's4';
  if (/^Unternehmensanalyse/i.test(leistung)) return portal ? 's1' : 's2';
  return 's6';
}

/** Kaltmails: Variante der Kampagne → Vorlage */
export const KALT_VORLAGE: Record<string, string> = { 'Website verbesserbar': 'a1', 'keine Website': 'a2', 'Website nicht erreichbar': 'a3', 'Nachfass 1': 'a4' };

/** Gruß gehört in den Abschluss, nicht in den Text: nur ergänzen, wenn er nicht schon dasteht (Signatur oder von Hand geschriebener Text) */
export const GRUSS = 'Mit freundlichen Grüßen';
const hatGruss = (s: string) => /(freundlichen|viele|beste|herzliche) gr(ü|ue)(ß|ss)e/i.test(s);
export function mitGruss(text: string, abschluss = ''): string {
  const t = text.trimEnd(), a = abschluss.trim();
  // Die Signatur bringt den Gruß mit: ein Gruß am Ende des Texts (Leerentwurf, KI-Entwurf) fällt weg
  if (hatGruss(a)) return `${t.replace(/\n\s*(mit freundlichen|freundliche|viele|beste|herzliche) gr(ü|ue)(ß|ss)e,?\s*$/i, '').trimEnd()}\n\n${a}`;
  if (hatGruss(t.split('\n').slice(-3).join('\n'))) return a ? `${t}\n${a}` : t;
  return `${t}\n\n${GRUSS}${a ? `\n${a}` : ''}`;
}

/** Terminart → Vorlage (k5 Verschieben: Beschreibung aus k5, Titel bleibt der der Terminart) */
export const TV_ART: Record<string, string> = { 'Erstgespräch': 'k1', 'Weiterer Termin – Closer': 'k2', 'Berater-Erstgespräch': 'k3', 'Weiterer Termin – Berater': 'k4' };
export interface TerminVorlage { id: string; betreff: string | null; text: string }
/** Vorbelegung von Titel und Beschreibung beim Buchen; ohne gewählte Zeit steht „…“ */
export function terminEntwurf(V: TerminVorlage[], art: string, w: { anrede: string; firma: string; person?: string; slot?: string | null; verschieben?: boolean }) {
  const k = TV_ART[art] ?? 'k1', m = w.slot?.match(/^(.*) (\d\d:\d\d)$/);
  const werte = { 'Sehr geehrte': w.anrede, Person: w.person || '…', Firma: w.firma, Datum: m ? m[1] : '…', Uhrzeit: m ? m[2] : '…' };
  const von = (id: string) => V.find(v => v.id === id);
  return { titel: vlFill(von(k)?.betreff ?? '', werte), text: vlFill(von(w.verschieben ? 'k5' : k)?.text ?? '', werte) };
}
